/**
 * Implementation of step first of onboarding process
 * 
 * @author - Harsh Tomar
 */

// Dependencies
import React from "react";
import StepOne from "../../../components/CreateMonitor/StepOne";
import Welcome from "./../../../images/welcome.svg";

export default function MonitorInfo() {

  return (
    <div className="flex">
      <div className="w-1/3 bg-accent rounded-tl-xl rounded-bl-xl flex flex-col pt-28 items-center">
        <img src={Welcome} width={200} className="mb-4"/>
        <h1 className="text-2xl text-white mb-4">Welcome Harsh!</h1>
        <p className="text-center text-white">You can monitor your API, Website and SSL certificates.</p>
      </div>
      <div className="flex-1 p-8">
        <h1 className="text-2xl my-4 text-center">Welcome Harsh! Let's create your first monitor</h1>
        {/* <h1> Create Monitor </h1> */}
        <StepOne />
      </div>
    </div>
  )
}